import { PrimaryInverseButtonXSmall, PrimaryInverseButtonSmall, PrimaryInverseButtonMedium, PrimaryInverseButtonLarge, PrimaryButtonXSmall, PrimaryButtonSmall, PrimaryButtonSmallAlt, PrimaryButtonMedium, PrimaryButtonLarge } from './variants/PrimaryButton.js';
import { SecondaryButtonXSmall, SecondaryButtonSmall, SecondaryButtonMedium, SecondaryButtonLarge } from './variants/SecondaryButton.js';
import { OutlineButtonXSmall, OutlineButtonSmall, OutlineButtonMedium, OutlineButtonLarge } from './variants/OutlineButton.js';
import { GhostInverseButtonXSmall, GhostInverseButtonSmall, GhostInverseButtonMedium, GhostInverseButtonLarge, GhostButtonXSmall, GhostButtonSmall, GhostButtonMedium, GhostButtonLarge } from './variants/GhostButton.js';

const getButtonComponent = (variant, size) => {
    switch (variant) {
        case 'primary':
            if (size === 'xSmall')
                return PrimaryButtonXSmall;
            if (size === 'small')
                return PrimaryButtonSmall;
            if (size === 'small-alt')
                return PrimaryButtonSmallAlt;
            if (size === 'medium')
                return PrimaryButtonMedium;
            return PrimaryButtonLarge;
        case 'secondary':
            if (size === 'xSmall')
                return SecondaryButtonXSmall;
            if (size === 'small' || size === 'small-alt')
                return SecondaryButtonSmall;
            if (size === 'medium')
                return SecondaryButtonMedium;
            return SecondaryButtonLarge;
        case 'outline':
            if (size === 'xSmall')
                return OutlineButtonXSmall;
            if (size === 'small' || size === 'small-alt')
                return OutlineButtonSmall;
            if (size === 'medium')
                return OutlineButtonMedium;
            return OutlineButtonLarge;
        case 'ghost':
            if (size === 'xSmall')
                return GhostButtonXSmall;
            if (size === 'small' || size === 'small-alt')
                return GhostButtonSmall;
            if (size === 'medium')
                return GhostButtonMedium;
            return GhostButtonLarge;
        case 'inverse':
            if (size === 'xSmall')
                return PrimaryInverseButtonXSmall;
            if (size === 'small' || size === 'small-alt') {
                return PrimaryInverseButtonSmall;
            }
            if (size === 'medium')
                return PrimaryInverseButtonMedium;
            return PrimaryInverseButtonLarge;
        case 'inverse-ghost':
            if (size === 'xSmall')
                return GhostInverseButtonXSmall;
            if (size === 'small' || size === 'small-alt') {
                return GhostInverseButtonSmall;
            }
            if (size === 'medium')
                return GhostInverseButtonMedium;
            return GhostInverseButtonLarge;
        default:
            throw new Error('Error, incorrect props. Pass the correct set of props');
    }
};
function getSpinnerVariant(variant) {
    switch (variant) {
        case 'primary':
        case 'inverse-ghost':
            return 'inverse';
        default:
            return 'secondary';
    }
}

export { getButtonComponent, getSpinnerVariant };
